import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import { ResponsiveBar } from '@nivo/bar';

// https://www.npmjs.com/package/react-d3-speedometer
// https://nivo.rocks/pie/

class nonPayment extends Component {
  
  returnBalance = (year, nonPayment) => {
    let balance = 0;
    let firstYear = nonPayment.first ? nonPayment.first.year : 0;
    let secondYear = nonPayment.second ? nonPayment.second.year : 0;

    if(firstYear === year) {
      balance = nonPayment.first.balance;
    } else if(secondYear === year) {
      balance = nonPayment.second.balance;
    };
    return this.props.transformCurrency(balance);
  }


  render() {
    const {
      nonPayment,
      tip
    } = this.props;

    return (
      <div className="div-indicador">
        <Card>
          <Card.Header style={{ fontWeight: 'bold' }}>
            Inadimplência
            <div data-tip={tip} className="fas fa-info-circle ml-1" />
          </Card.Header>
          <Card.Body>
            <div className="bar">
              <ResponsiveBar
                data={[
                  {
                    "year": nonPayment ? nonPayment.first ? nonPayment.first.year : '' : '',
                    "saldo": nonPayment ? nonPayment.first ? nonPayment.first.saldo : '' : '',
                    "Inadimplência": nonPayment ? nonPayment.first ? nonPayment.first.percentage : '' : ''
                  },
                  {
                    "year": nonPayment ? nonPayment.second ? nonPayment.second.year : '' : '',
                    "saldo": nonPayment ? nonPayment.second ? nonPayment.second.saldo : '' : '',
                    "Inadimplência": nonPayment ? nonPayment.second ? nonPayment.second.percentage : '' : ''
                  }
                ]}
                keys={[ 'Inadimplência' ]}
                indexBy="year"
                margin={{ top: 20, right: 30, bottom: 30, left: 60 }}
                padding={0.3}
                valueScale={{ type: 'linear' }}
                indexScale={{ type: 'band', round: true }}
                colors={{ scheme: 'set1' }}
                borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                axisTop={null}
                axisRight={null}
                tooltip={d => <span style={{ backgroundColor: '#FFFF', padding: '5px 10px', border: '1px solid #000' }} >{`${d.label}: ${d.value}% - R$${this.returnBalance(d.data.year, nonPayment)}` }</span>}
                axisLeft={{
                    tickSize: 1,
                    tickValues: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: 'Inadimplência (%)',
                    legendPosition: 'middle',
                    legendOffset: -50,
                    format: value =>
                      `${value}%`,
                }}
                label={d => <span style={{ fontSize: '14px', fontWeight: 'bold' }} y={ -10 }>{`${d.value}%`}</span>}
                labelSkipWidth={12}
                labelSkipHeight={0}
                labelTextColor={'#00'}
                role="application"
              />
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default nonPayment;
